export default {
    '001':'เงินสด',
    '009':'พร้อมเพย์',
    '036':'พร้อมเพย์(static)',
    '035':'เงินเซ็น',
    '037':'บัตรสวัสดิการ',
  }